import Axios from "axios";

const approveSiteVisit = async (id, token) =>
  await Axios.post(`${window.API}/site-visit/approve/${id}`, [], {
    headers: { Authorization: `Bearer ${token}` },
  });

export { approveSiteVisit };
